<template>
    <div class="editor-container">
        <div id="editor" class="editor"></div>
    </div>
</template>

<script>
import {loadJsResource} from "@/service/util";
import {onMounted} from "vue";
export default {
    name: "GUeditor",
    setup() {
        let editorInstance = null;
        let editorInstance_2 = null;
        onMounted(() => {
            const config = {
                initialFrameHeight:400,
                initialFrameWidth:1300,
                serverUrl: "https://api.jfinfo.com/api/ueditor/php",
            }
            const config_2 = {
                initialFrameHeight:300,
                initialFrameWidth:1300,
                serverUrl: "https://api.jfinfo.com/api/ueditor/php",
                zIndex : 1
            }
            if(!window.UE) {
                const scripts = ['static/ueditor/ueditor.config.js','static/ueditor/ueditor.all.js'];
                loadJsResource(scripts, process.env.BASE_URL).then(()=>{
                    if(window.UE) {
                        editorInstance = window.UE.getEditor('editor', config);
                        editorInstance_2 = window.UE.getEditor('editor_2', config_2);
                    }
                })
            }
        })
        const getContent = () => {
            return editorInstance.getContent()
        }
        const getContent2 = () => {
            return editorInstance_2.getContent()
        }
        return {
            getContent,
            getContent2,
        }
    }
}
</script>

<style scoped>

</style>
